import { RiskboxComponent } from '../riskbox/riskbox.component';
import { StarRatingComponent } from './star-rating/star-rating.component';

import { AuthService } from '../../auth/auth.service';
import { EgpSeason, EgpService } from '../egp.service';
import { LanguageService } from 'src/app/shared/services/language.service';

import { DatexPipe } from '../../shared/datex.pipe';
import { DiffColorPipe } from './pipes/diff-color.pipe';

import { CdkScrollable } from '@angular/cdk/scrolling';
import { CommonModule } from '@angular/common';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import {
  Component,
  computed,
  ElementRef,
  inject,
  OnInit,
  signal,
  viewChild,
} from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogConfig,
  MatDialogModule,
  MatDialogRef,
} from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { MatSelectionListChange } from '@angular/material/list';
import { MatTooltipModule } from '@angular/material/tooltip';

import { TranslateModule } from '@ngx-translate/core';

import { environment } from '../../../environments/environment';

import { diffColor } from './constants/constants';
import moment from 'moment';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

export const MODULES_1 = [
  CommonModule,
  MatCardModule,
  MatDividerModule,
  MatIconModule,
  MatButtonModule,
  MatTooltipModule,
  TranslateModule,
];
export const COMPONENTS_1 = [StarRatingComponent, RiskboxComponent];
export const PIPES_1 = [DatexPipe, DiffColorPipe];

@Component({
  selector: 'app-verification',
  templateUrl: './verification.component.html',
  styleUrls: ['./verification.component.scss'],
  providers: [EgpService],
  imports: [...MODULES_1, ...COMPONENTS_1, ...PIPES_1],
})
export class VerificationComponent implements OnInit {
  private auth = inject(AuthService);
  private http = inject(HttpClient);
  private egpService = inject(EgpService);
  public dialog = inject(MatDialog);
  public languageService = inject(LanguageService);

  egpCard = viewChild<ElementRef>('egpCard');

  isMaster: boolean;
  showAllStations: boolean;
  loading = signal<boolean>(undefined);
  favoriteAreaId = '86';
  favoriteAreaIdDummy = '410';
  egpAreas = signal([]);
  selectedArea = signal<any>(undefined);
  egpData = signal<any>(undefined);
  riskBoxValues = signal<any>(undefined);
  starsEgp = signal<any>(undefined);
  starsVerification = signal({
    EIS: 0,
    SCHNEE: 0,
    REIF: 0,
    NAESSE: 0,
  });

  colors = {
    EIS: '#e14b7e',
    SCHNEE: '#f9715f',
    NAESSE: '#373f43',
    REIF: '#9e9e9e',
  };

  values = {
    0: 'NO_SLICKNESS',
    1: 'BRIDGES',
    2: 'EXPOSED_AREAS',
    3: 'MANY_SECTIONS',
    4: 'WHOLE_AREA',
  };

  gSomething = {
    0: '',
    1: 'Gx = ',
    2: 'G1 = ',
    3: 'G2 = ',
    4: 'G3 = ',
  };

  media = signal<string>(undefined);
  showMini = computed(() => {
    return this.media() === 'xs';
  });

  gridCols = 2;
  gridByBreakpoint = {
    xl: 2,
    lg: 2,
    md: 1,
    sm: 1,
    xs: 1,
  };

  texts = signal<any[]>(undefined);

  get egpSeason() {
    return EgpSeason;
  }

  ngOnInit(): void {
    this.loading.set(true);

    this.isMaster = this.auth.isMaster();
    this.showAllStations = this.isMaster && !this.auth.getCustomerAlias();
    this.getAreaIds();
  }

  getAreaIds(): void {
    const customerDocument = this.auth.getCustomerDocument();
    if (this.showAllStations) {
      this.getProductMaster('');
    } else if (
      customerDocument.egpProducts.filter(product =>
        this.auth.isProductActive('egpProducts', product.id)
      ).length > 0
    ) {
      const egpProducts = customerDocument.egpProducts.filter(product =>
        this.auth.isProductActive('egpProducts', product.id)
      );
      this.getProductData(egpProducts);
    }
  }

  getProductData(egpProducts): void {
    this.egpAreas.set([]);
    this.egpService.getAllEgpAreas(EgpSeason.WINTER).then(data => {
      for (const area of data) {
        if (this.isEgpAreaOrdered(area.id, egpProducts)) {
          const egpArea = {
            areaId: area.id,
            name: area.name,
            station: area.station,
            deadline: '12:00',
          };
          if (
            this.favoriteAreaId !== area.id &&
            this.favoriteAreaIdDummy !== area.id
          ) {
            continue;
          }
          this.egpAreas.update(egpAreas => {
            return [...egpAreas, egpArea];
          });
          if (!this.selectedArea()) {
            this.selectedArea.set({ ...egpArea });
          }
        }
      }
      this.loading.set(false);
      this.onAreaSelect(this.selectedArea());
    });
  }

  getFirstDeadlineforArea(areaId, egpProducts): string {
    let minDeadline = '23:00';
    for (const product of egpProducts.filter(p => p.areaId == areaId)) {
      for (const deadline of product.deadlines) {
        if (deadline < minDeadline) {
          minDeadline = deadline;
        }
      }
    }
    return minDeadline;
  }

  isEgpAreaOrdered(areaId, egpProducts): boolean {
    return egpProducts.filter(p => p.areaId == areaId).length > 0;
  }

  getProductMaster(season): void {
    this.egpAreas.set([]);
    let favoriteArea: any;
    this.egpService.getAllEgpAreas(EgpSeason.WINTER).then(data => {
      for (const area of data) {
        const egpArea = {
          areaId: area.id,
          name: area.name,
          station: area.station,
          // deadline: this.getFirstDeadlineforArea(area.id, egpProducts)
          deadline: '12:00',
        };
        if (this.favoriteAreaId && area.id === this.favoriteAreaId) {
          favoriteArea = egpArea;
        }
        this.egpAreas.update(egpAreas => {
          return [...egpAreas, egpArea];
        });
      }
      this.onAreaSelect(favoriteArea ? favoriteArea : this.egpAreas()[0]);
    });
  }

  getEgpData(egpArea): void {
    this.egpService
      .getPreviousEgpOfDeadline(egpArea.areaId, egpArea.deadline)
      .then(data => {
        this.egpData.set({ ...data });
        this.riskBoxValues.set({
          ...this.egpService.getRiskBoxValues(data['matrices'])[0],
        });
        const riskBoxValue = this.riskBoxValuesStars(data['matrices'])[0];
        this.starsEgp.set({
          EIS: riskBoxValue['EIS']['area'] * 4,
          SCHNEE: riskBoxValue['SCHNEE']['area'] * 4,
          REIF: riskBoxValue['REIF']['area'] * 4,
          NAESSE: riskBoxValue['NAESSE']['area'] * 4,
        });
        this.starsVerification.set({ ...this.starsEgp() });
        this.texts.set([
          ...this.egpService.formatTexts(this.egpData().textObject.texts),
        ]);
      });
  }

  riskBoxValuesStars(matrices): Array<any> {
    const riskBoxes = [];
    for (const matrix of matrices) {
      const riskBox = {
        EIS: {
          area: this.egpService.calcArea(
            matrix['freezingRain']['regionPercent']
          ),
          risk: matrix['freezingRain']['riskPercent'],
        },
        SCHNEE: {
          area: this.egpService.calcArea(matrix['snow']['regionPercent']),
          risk: matrix['snow']['riskPercent'],
        },
        REIF: {
          area: this.egpService.calcArea(matrix['rime']['regionPercent']),
          risk: matrix['rime']['riskPercent'],
        },
        NAESSE: {
          area: this.egpService.calcArea(
            matrix['freezingWet']['regionPercent']
          ),
          risk: matrix['freezingWet']['riskPercent'],
        },
      };
      riskBoxes.push(riskBox);
    }
    return riskBoxes;
  }

  doRating(): void {}

  onAreaSelect(egpArea): void {
    this.selectedArea.set({ ...egpArea });
    this.getEgpData(egpArea);
  }

  onAreaChange(event: MatSelectionListChange): void {
    this.onAreaSelect(event);
  }

  diffColor(quadrant): string {
    return diffColor(quadrant, this.starsEgp, this.starsVerification());
  }

  onReset(): void {
    this.starsVerification.set({ ...this.starsEgp() });
  }

  onSave(): void {
    const egpRisk = this.extractRiskValues();
    const saveObject = {
      author: JSON.parse(localStorage.getItem('user_customer_document'))[
        'name'
      ],
      customerId: JSON.parse(localStorage.getItem('user_customer_document'))[
        'customerId'
      ],
      dtg: this.egpData()['textObject']['prescribeAt'],
      egpArea: this.selectedArea().areaId - 0,
      freezing_rain_observed: this.starsVerification()['EIS'],
      freezing_rain_region: this.starsEgp()['EIS'],
      freezing_rain_risk: egpRisk['EIS'],
      freezing_wet_observed: this.starsVerification()['NAESSE'],
      freezing_wet_region: this.starsEgp()['NAESSE'],
      freezing_wet_risk: egpRisk['NAESSE'],
      insert_dtg: moment().utc().toISOString(),
      rime_observed: this.starsVerification()['REIF'],
      rime_region: this.starsEgp()['REIF'],
      rime_risk: egpRisk['REIF'],
      snow_observed: this.starsVerification()['SCHNEE'],
      snow_region: this.starsEgp()['SCHNEE'],
      snow_risk: egpRisk['SCHNEE'],
    };
    this.onSaveData(saveObject).subscribe(
      data => {},
      err => {
        console.error('Error:', err);
        this.handleError(err);
      }
    );
  }

  onSaveData(data: any): Observable<any> {
    const body = JSON.stringify(data);
    return this.http
      .post(environment.url.bff + '/verification/customer', body, {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
        }),
        responseType: 'text',
      })
      .pipe(map(response => this.handleSaveData(response)));
  }

  handleError(error): void {
    if (error.status === 200) {
      this.openDialog('Ihre Verifikation wurde erfolgreich gespeichert.');
    } else if (error.status === 409) {
      const datum = moment(this.egpData()['textObject']['prescribeAt']).format(
        'DD.MM.YYYY HH:mm'
      );
      this.openDialog(
        'Ihre Verifikation konnte nicht gespeichert werden, da Sie sie bereits zum Zeitpunkt ' +
          datum +
          ' Uhr gespeichert haben.'
      );
    } else {
      const datum = moment(this.egpData()['textObject']['prescribeAt']).format(
        'DD.MM.YYYY HH:mm'
      );
      this.openDialog(
        'Fehler: Ihre Verifikation konnte nicht gespeichert werden.'
      );
    }
  }

  handleSaveData(response): void {
    if (response === 200 || response === '200' || response === 'ok') {
      this.openDialog('Ihre Verifikation wurde erfolgreich gespeichert.');
    } else {
      const datum = moment(this.egpData()['textObject']['prescribeAt']).format(
        'DD.MM.YYYY HH:mm'
      );
      this.openDialog(
        'Ihre Verifikation konnte nicht gespeichert werden, da Sie sie bereits zum Zeitpunkt ' +
          datum +
          ' Uhr gespeichert haben.'
      );
    }
  }

  extractRiskValues(): any {
    return {
      EIS: this.riskBoxValues()['EIS']['risk'],
      SCHNEE: this.riskBoxValues()['SCHNEE']['risk'],
      REIF: this.riskBoxValues()['REIF']['risk'],
      NAESSE: this.riskBoxValues()['NAESSE']['risk'],
    };
  }

  openDialog(dialog): void {
    const dialogConfig = new MatDialogConfig();

    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = true;

    dialogConfig.data = {
      text: dialog,
    };

    const dialogRef = this.dialog.open(DialogMessageComponent, dialogConfig);

    dialogRef.afterClosed().subscribe();
  }

  onRatingChanged(quadrant, rating): void {
    this.starsVerification.update(starsVerification => {
      return { ...starsVerification, [quadrant]: rating };
    });
  }
}

export const MODULES_2 = [MatDialogModule, TranslateModule];
export const DIRECTIVES_2 = [CdkScrollable];
@Component({
  selector: 'app-dialog-message',
  styles: [],
  template: ` <mat-dialog-content>
      <p>{{ description().text }}</p>
    </mat-dialog-content>
    <mat-dialog-actions>
      <button
        style="float: right"
        class="mat-stroked-button mat-primary"
        (click)="close()">
        {{ 'BUTTON.ok' | translate }}
      </button>
    </mat-dialog-actions>`,
  imports: [...MODULES_2, ...DIRECTIVES_2],
})
export class DialogMessageComponent {
  private dialogRef = inject(MatDialogRef<DialogMessageComponent>);
  public data = inject(MAT_DIALOG_DATA);

  // form: FormGroup;
  description = signal<any>(undefined);

  constructor() {
    this.description.set({ ...this.data });
  }
  close(): void {
    this.dialogRef.close();
  }
}
